const LOGIN = 'login'
const MAIN = 'main'
const TRANSACTION = 'transaction'
const HISTORY = 'history'
const ANALYTIC = 'analytic'
const MERCHANT = 'merchant'
const DEVICE = 'device'
const BANK = 'bank'
const PAYMENT_TERMINAL = "payment-terminal"
const SETTING = 'setting'
const CUSTOMER = 'customer'
const CUSTOMER_FACEPAY = 'customer-facepay'
const CUSTOMER_BANK = 'customer-bank'
const LOCATION = 'location'
const PERMISSION = "permission"
const CENSORSHIP = "censorship"
const WAITING_CENSORSHIP = "waiting-censorship"
const REJECTION_PROFILE = "rejection-profile"
const BUSSINESS_MANAGE = 'business-manage'


export {
    LOGIN,
    MAIN,
    TRANSACTION,
    HISTORY,
    ANALYTIC,
    MERCHANT,
    DEVICE,
    BANK,
    PAYMENT_TERMINAL,
    SETTING,
    CUSTOMER,
    CUSTOMER_FACEPAY,
    CUSTOMER_BANK,
    LOCATION, 
    PERMISSION,
    CENSORSHIP,
    WAITING_CENSORSHIP,
    REJECTION_PROFILE,
    BUSSINESS_MANAGE
}